import { render } from "./order-details.vue?vue&type=template&id=e8b3533e&scoped=true"
import script from "./order-details.vue?vue&type=script&lang=js"
export * from "./order-details.vue?vue&type=script&lang=js"

import "./order-details.vue?vue&type=style&index=0&id=e8b3533e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8b3533e"]])

export default __exports__